<template>
    <div class="publication__progress">
        <div class="publication__progress-step">{{stepInfo.info.step}}</div>
        <div class="publication__progress-description">{{stepInfo.info.title}}</div>
        <div class="publication__progress-load">
            <div class="publication__progress-loader"
                 :style="{width: (((100 / +stepInfo.count) * (stepInfo.info.step - 1)).toFixed() + '%')}" ></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "PublicationProgress",
    props: ['stepInfo'],
}
</script>

<style scoped>

</style>
